import { render } from "./BlogPostPage.vue?vue&type=template&id=22663dd0"
import script from "./BlogPostPage.vue?vue&type=script&lang=js"
export * from "./BlogPostPage.vue?vue&type=script&lang=js"

import "./BlogPostPage.vue?vue&type=style&index=0&id=22663dd0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__